<div class="card" [formGroup]="form">
  <div class="card-body">
    <fieldset class="col-12">
      <legend>Datos Generales</legend>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-4">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Nacionalidad</label>
              <div class="col-lg-12">
                <select class="form-control" formControlName="per_in_nationality" [(ngModel)]="select_nationality">
                  <option value="">SELECCIONAR</option>
                  <ng-container *ngFor="let item of parameters">
                    <option *ngIf="item.sys_in_group == 300" [ngValue]="item.sys_in_parameter">
                      {{item.sys_vc_description}}</option>
                  </ng-container>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-4">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Tipo Documento</label>
              <div class="col-lg-12">
                <select class="form-control" formControlName="per_in_document_type" [(ngModel)]="select_type_document">
                  <option value="">SELECCIONAR</option>
                  <ng-container *ngFor="let item of parameters">
                    <option *ngIf="item.sys_in_group == 100" [ngValue]="item.sys_in_parameter">
                      {{item.sys_vc_description}}</option>
                  </ng-container>
                </select>
              </div>
            </div>

            <div class="col-lg-4">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Nro Documento</label>
              <div class="col-lg-12">
                <input type="text" class="form-control" formControlName="per_vc_document_number" />
              </div>
            </div>
            <div class="col-auto">
              <label class="col-lg-12">&nbsp;</label>
              <button *ngIf="!editActivo" class="btn btn-badminton btn-sm pull-right" (click)="getpersona()">Buscar</button>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Nombres</label>
              <div class="col-lg-12">
                <input type="text" class="form-control" formControlName="per_vc_first_name" />
              </div>
            </div>

            <div class="col-lg-6">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Apellidos</label>
              <div class="col-lg-12">
                <input type="text" class="form-control" formControlName="per_vc_last_name" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-4">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Institución</label>
              <div class="col-lg-12">
                <select class="form-control" formControlName="stu_in_institution" [(ngModel)]="select_stu_in_institution">
                  <option value="">Seleccionar</option>
                  <ng-container *ngFor="let item of parameters">
                    <option *ngIf="item.sys_in_group == 1300" [ngValue]="item.sys_in_parameter">
                      {{item.sys_vc_description}}</option>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Genero</label>
              <div class="col-lg-12">
                <select class="form-control" formControlName="per_in_gender" [(ngModel)]="select_per_in_gender">
                  <option value="">Seleccionar</option>
                  <ng-container *ngFor="let item of parameters">
                    <option *ngIf="item.sys_in_group == 200" [ngValue]="item.sys_in_parameter">
                      {{item.sys_vc_description}}</option>
                  </ng-container>
                </select>
              </div>
            </div>

            <div class="col-lg-4">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Celular</label>
              <div class="col-lg-12">
                <input type="text" class="form-control" formControlName="per_vc_cellphone">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Correo Electronico</label>
              <div class="col-lg-12">
                <input type="text" class="form-control" formControlName="per_vc_email" />
              </div>
            </div>
          </div>

       


          <div class="row">
            <div class="col-lg-4">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Departamento</label>
              <div class="col-lg-12">
                <select class="form-control" formControlName="per_in_departament" [(ngModel)]="select_per_in_departament"
                (change)="onChangeDepartment($event.target.value)">
                  <option value="">SELECCIONAR</option>
                  <ng-container *ngFor="let item of department">
                    <option value="{{item.dep_in_id}}">
                      {{item.dep_vc_name}}</option>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Provincia</label>
              <div class="col-lg-12">
                <select class="form-control" formControlName="per_in_province" [(ngModel)]="select_per_in_province"
                (change)="onChangeProvince($event.target.value)">
                  <option value="">SELECCIONAR</option>
                  <ng-container *ngFor="let item of province_filter">
                    <option value="{{item.prv_in_id}}">
                      {{item.prv_vc_name}}</option>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Distrito</label>
              <div class="col-lg-12">
                <select class="form-control" formControlName="per_in_district" [(ngModel)]="select_per_in_district">
                  <option value="">SELECCIONAR</option>
                  <ng-container *ngFor="let item of district_filter">
                    <option  value="{{item.dis_in_id}}">
                      {{item.dis_vc_name}}</option>
                  </ng-container>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Dirección</label>
              <div class="col-lg-12">
                <input type="text" class="form-control" formControlName="per_vc_address" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </fieldset>

    <fieldset class="col-12">
      <legend>Rol y Usuario</legend>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-4">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Rol</label>
              <div class="col-lg-12">
                <select class="form-control" formControlName="rol_in_type" [(ngModel)]="select_rol_in_type">
                  <option value="1">Estudiante</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Usuario</label>
              <div class="col-lg-12">
                <input type="text" class="form-control" formControlName="usu_vc_login" />
              </div>
            </div>
            <div class="col-lg-4">
              <label class="col-lg-12 col-form-label lbl-label-sub-titulo">Contraseña</label>
              <div class="col-lg-12">
                <input type="password" class="form-control" formControlName="usu_tx_password" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </fieldset>
    <br>
    <div class="d-flex flex-row-reverse"  >
      <div class="col-lg-2">
        <button class="btn btn-badminton btn-sm pull-right" (click)="register()">Guardar</button>
      </div>
      <div class="col-lg-2">
        <button class="btn btn-badminton btn-sm pull-right" (click)="afterSave()" >Cerrar</button>
      </div>
      <div class="col-lg-2">
        <button class="btn btn-badminton btn-sm pull-right" (click)="FormClean()">Limpiar</button>
      </div>
    </div>
  </div>
</div>